import React from 'react';
import PropTypes from 'prop-types';

import dataModel from '../../../models/DataModel';

import './GenericTextBanner.scss';

// TODO: collapse other banners into this

/**
 * <GenericTextBanner> - child component of <GlobalBanner>
 */
export default class GenericTextBanner extends React.Component {

  constructor(props) {
    super(props);
    GenericTextBanner.propTypes = {
      /** Text to display in the banner */
      text: PropTypes.string,
      /** If true, there is an X on the right which closes the banner */
      hasCloseButton: PropTypes.bool,
      /** If true, the banner renders on the bottom of the screen instead of the top */
      isBottomBanner: PropTypes.bool,
      /** True if the parent component is persisted in local storage for the given user/company */
      isCompanyBanner: PropTypes.bool,
      /** Banner type passed to component to clear it in localstorage */
      bannerType: PropTypes.string,
    };
    this.state = {
      shown: false,
    };

    this.closeBanner = this.closeBanner.bind(this);
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ shown: true });
    }, 0);
  }

  /** HELPERS */
  closeBanner() {
    return new Promise((resolve) => {
      this.setState({ shown: false });
      // wait for animation to actually close banner
      setTimeout(() => {
        resolve();
        // hide the component
        dataModel.hideGlobalBanner(this.props.bannerType, this.props.isCompanyBanner);
      }, 150);
    });
  }

  render() {
    const { text, hasCloseButton, isBottomBanner, className } = this.props;

    return (
      <span className={className+' banner' + (this.state.shown ? '' : ' banner--closing') + (isBottomBanner ? ' banner--bottom' : '')}>
        <span className="banner__text">
          {text}
        </span>
        {
          hasCloseButton && 
          <span className="banner__close" onClick={this.closeBanner}>&times;</span>
        }
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/banners/GenericTextBanner/index.js